'use client';

import React, { MouseEvent } from 'react';
import { Wallet } from '@drift-labs/icons';
import useModal from 'src/components/Modals/hooks/useModal';
import TextButton from 'src/components/primitives/TextButton/TextButton';
import { useAppInitialLoadContext } from 'src/providers/app/AppInitialLoadProvider/AppInitialLoadProvider';

const SecondaryConnectWalletButton = () => {
	const { show } = useModal();
	const { isInitialLoading } = useAppInitialLoadContext();

	const handleClick = (e: MouseEvent) => {
		e.stopPropagation();
		show({ type: 'connect_wallet', props: {} });
	};

	return (
		<div className="xs:py-8 sm:py-0">
			<TextButton
				size="md"
				variant="tertiary"
				onClick={handleClick}
				leftIcon={Wallet}
				disabled={isInitialLoading}
			>
				Connect Wallet
			</TextButton>
		</div>
	);
};

export default SecondaryConnectWalletButton;
